<template>
  <div class="info-page">
    <div class="info-shell">
      <nav class="info-crumbs">
        <router-link to="/">Home</router-link>
        <span>/</span>
        <span>{{ page.title }}</span>
      </nav>

      <header class="info-hero">
        <p class="info-kicker">Site information</p>
        <h1>{{ page.title }}</h1>
        <p>{{ page.hero }}</p>
      </header>

      <section class="info-grid">
        <article class="info-card" v-for="section in page.sections" :key="section.heading">
          <h2>{{ section.heading }}</h2>
          <p>{{ section.body }}</p>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
import pageData from "@/common/config/info-pages.json"

export default {
  name: "InfoPage",
  computed: {
    page() {
      var key = this.$route.meta.pageKey
      return pageData[key] || {
        title: "Information",
        hero: "",
        sections: []
      }
    }
  }
}
</script>

<style scoped>
.info-page {
  min-height: 100vh;
  color: #f8fafc;
  background:
    radial-gradient(circle at top left, rgba(255, 128, 88, 0.16), transparent 28%),
    linear-gradient(180deg, #050607 0%, #0a0d12 45%, #050607 100%);
}

.info-shell {
  width: min(1080px, calc(100% - 32px));
  margin: 0 auto;
  padding: 28px 0 40px;
}

.info-crumbs {
  display: flex;
  gap: 10px;
  margin-bottom: 18px;
  color: rgba(226, 232, 240, 0.74);
  font: 600 12px/1.4 "Courier New", monospace;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.info-hero,
.info-card {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 28px;
  background: rgba(10, 12, 16, 0.92);
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.3);
}

.info-hero {
  padding: 28px;
  margin-bottom: 22px;
}

.info-kicker {
  margin-bottom: 14px;
  color: rgba(226, 232, 240, 0.7);
  font: 600 12px/1.4 "Courier New", monospace;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.info-hero h1 {
  margin-bottom: 14px;
  font: 700 clamp(34px, 4vw, 54px)/1.02 Georgia, serif;
  letter-spacing: -0.04em;
}

.info-hero p,
.info-card p {
  color: rgba(226, 232, 240, 0.84);
  font-size: 16px;
  line-height: 1.8;
}

.info-grid {
  display: grid;
  gap: 18px;
}

.info-card {
  padding: 24px;
}

.info-card h2 {
  margin-bottom: 12px;
  font: 700 28px/1.1 Georgia, serif;
}

@media (max-width: 640px) {
  .info-shell {
    width: min(100%, calc(100% - 20px));
    padding-top: 18px;
  }

  .info-hero,
  .info-card {
    padding: 18px;
    border-radius: 20px;
  }

  .info-card h2 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/InfoPage.vue